import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\Internal\Report\GeneratePdfImageController::__invoke
* @see app/Http/Controllers/Api/Internal/Report/GeneratePdfImageController.php:15
* @route '/internal-api/reports/{report}/generate-pdf-image'
*/
export const generatePdfImage = (args: { report: string | { id: string } } | [report: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: generatePdfImage.url(args, options),
    method: 'post',
})

generatePdfImage.definition = {
    methods: ["post"],
    url: '/internal-api/reports/{report}/generate-pdf-image',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\Internal\Report\GeneratePdfImageController::__invoke
* @see app/Http/Controllers/Api/Internal/Report/GeneratePdfImageController.php:15
* @route '/internal-api/reports/{report}/generate-pdf-image'
*/
generatePdfImage.url = (args: { report: string | { id: string } } | [report: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { report: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { report: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            report: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        report: typeof args.report === 'object'
        ? args.report.id
        : args.report,
    }

    return generatePdfImage.definition.url
            .replace('{report}', parsedArgs.report.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Internal\Report\GeneratePdfImageController::__invoke
* @see app/Http/Controllers/Api/Internal/Report/GeneratePdfImageController.php:15
* @route '/internal-api/reports/{report}/generate-pdf-image'
*/
generatePdfImage.post = (args: { report: string | { id: string } } | [report: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: generatePdfImage.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\Internal\Report\ReportPdfController::__invoke
* @see app/Http/Controllers/Api/Internal/Report/ReportPdfController.php:13
* @route '/internal-api/reports/{report}/pdf'
*/
export const pdf = (args: { report: string | { id: string } } | [report: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pdf.url(args, options),
    method: 'get',
})

pdf.definition = {
    methods: ["get","head"],
    url: '/internal-api/reports/{report}/pdf',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\Internal\Report\ReportPdfController::__invoke
* @see app/Http/Controllers/Api/Internal/Report/ReportPdfController.php:13
* @route '/internal-api/reports/{report}/pdf'
*/
pdf.url = (args: { report: string | { id: string } } | [report: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { report: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { report: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            report: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        report: typeof args.report === 'object'
        ? args.report.id
        : args.report,
    }

    return pdf.definition.url
            .replace('{report}', parsedArgs.report.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Internal\Report\ReportPdfController::__invoke
* @see app/Http/Controllers/Api/Internal/Report/ReportPdfController.php:13
* @route '/internal-api/reports/{report}/pdf'
*/
pdf.get = (args: { report: string | { id: string } } | [report: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pdf.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Internal\Report\ReportPdfController::__invoke
* @see app/Http/Controllers/Api/Internal/Report/ReportPdfController.php:13
* @route '/internal-api/reports/{report}/pdf'
*/
pdf.head = (args: { report: string | { id: string } } | [report: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: pdf.url(args, options),
    method: 'head',
})

const reports = {
    generatePdfImage: Object.assign(generatePdfImage, generatePdfImage),
    pdf: Object.assign(pdf, pdf),
}

export default reports